import { PartnerCenterSeller } from "../../models/ticketing";
import { CountryValidationsData } from "../../server/crm/api/models/countryValidations";
import {
  AddressValidationAddress,
  AddressValidationRequest,
} from "../../server/partnerCenter/models/addressValidation";
import { MiddlewarePartner } from "../../server/partnerCenter/models/middlewarePartner";
import { PartnerCenterScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers";

export type AddressValidationStatus = "idle" | "loading" | "valid" | "suggestions" | "failed";

export type AddressValidationResult = {
  status: AddressValidationStatus;

  suggestedAddresses: AddressValidationAddress[];

  originalAddress: AddressValidationAddress;
};

export enum PartnerCenterActions {
  FETCH_COUNTRY_VALIDATION_START = "@countryValidation/FETCH_COUNTRY_VALIDATION_START",

  FETCH_COUNTRY_VALIDATION_COMPLETED = "@countryValidation/FETCH_COUNTRY_VALIDATION_COMPLETED",

  FETCH_COUNTRY_VALIDATION_ERROR = "@countryValidation/FETCH_COUNTRY_VALIDATION_ERROR",

  START_EARLY_ENROLLMENT_START = "@partnerCenter/START_EARLY_ENROLLMENT_START",

  START_EARLY_ENROLLMENT_COMPLETED = "@partnerCenter/START_EARLY_ENROLLMENT_COMPLETED",

  START_EARLY_ENROLLMENT_ERROR = "@partnerCenter/START_EARLY_ENROLLMENT_ERROR",

  VALIDATE_ADDRESS_START = "@addressValidation/VALIDATE_ADDRESS_START",

  VALIDATE_ADDRESS_COMPLETED = "@addressValidation/VALIDATE_ADDRESS_COMPLETED",

  VALIDATE_ADDRESS_ERROR = "@addressValidation/VALIDATE_ADDRESS_ERROR",

  VALIDATE_ADDRESS_RESET = "@addressValidation/VALIDATE_ADDRESS_RESET",

  VALIDATE_ADDRESS_CONFIRM_SUGGESTION = "@addressValidation/VALIDATE_ADDRESS_CONFIRM_SUGGESTION",

  UPDATE_SELLERS = "@partnerCenter/UPDATE_SELLERS",

  UPDATE_MIDDLEWARE_PARTNERS = "@partnerCenter/UPDATE_MIDDLEWARE_PARTNERS",
}

export const partnerCenterActions = {
  fetchCountryValidation: createOnboardingAsyncAction(
    PartnerCenterScope,

    PartnerCenterActions.FETCH_COUNTRY_VALIDATION_START,

    (country: string) => ({ country }),

    PartnerCenterActions.FETCH_COUNTRY_VALIDATION_COMPLETED,

    (data: CountryValidationsData, country: string) => ({
      data,

      country,
    }),

    PartnerCenterActions.FETCH_COUNTRY_VALIDATION_ERROR,

    (error: Error) => ({ error })
  ),

  updateSellers: createOnboardingAction(
    PartnerCenterActions.UPDATE_SELLERS,

    PartnerCenterScope,

    (sellers: PartnerCenterSeller[]) => ({
      sellers,
    })
  ),

  updateMiddlewarePartners: createOnboardingAction(
    PartnerCenterActions.UPDATE_MIDDLEWARE_PARTNERS,

    PartnerCenterScope,

    (middlewarePartners: MiddlewarePartner[]) => ({
      middlewarePartners,
    })
  ),

  startEarlyEnrollment: createOnboardingAsyncAction(
    PartnerCenterScope,

    PartnerCenterActions.START_EARLY_ENROLLMENT_START,

    (params?: {
      chunk?: Blob;

      chunkIndex?: number;

      totalChunks?: number;

      fileName?: string;

      uploadId?: string;

      dunsValue?: string;

      typeFile?: string;
    }) => ({ ...(params ?? {}) }),

    PartnerCenterActions.START_EARLY_ENROLLMENT_COMPLETED,

    () => ({}),

    PartnerCenterActions.START_EARLY_ENROLLMENT_ERROR,

    (error: Error) => ({ error })
  ),

  validateAddress: createOnboardingAsyncAction(
    PartnerCenterScope,

    PartnerCenterActions.VALIDATE_ADDRESS_START,

    (address: Omit<AddressValidationRequest, "validation_mode" | "secondary_validation_mode">) => ({
      ...address,
    }),

    PartnerCenterActions.VALIDATE_ADDRESS_COMPLETED,

    (result: AddressValidationResult) => ({ ...result }),

    PartnerCenterActions.VALIDATE_ADDRESS_ERROR,

    (error: Error) => ({ error })
  ),

  resetAddressValidation: createOnboardingAction(
    PartnerCenterActions.VALIDATE_ADDRESS_RESET,

    PartnerCenterScope,

    () => ({})
  ),

  confirmAddressSuggestion: createOnboardingAction(
    PartnerCenterActions.VALIDATE_ADDRESS_CONFIRM_SUGGESTION,

    PartnerCenterScope,

    (address: AddressValidationAddress) => ({ address })
  ),
};
